

import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Header from "../../components/Header";
import { Box, Button, TextField, Grid, useMediaQuery, useTheme, IconButton, InputBase, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import SearchIcon from '@mui/icons-material/Search';
import { putChapas, putChapaOrden } from '../../services/stock.services';
import { getOneDatos } from '../../services/interfoliacion.services';
import { getChapas, getSerieEtiqueta } from '../../services/ordenProduccion.services';
import ModalCaballete from '../../modal/caballete/modalCaballete';
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import ModalCharge from "../../modal/modalCharge";
import { tokens } from "../../theme";
import { PostDatosStockLaboratorio } from '../../services/laboratorio.services';
import { set } from 'date-fns';
import secureStorage from "../../utils/secureStorage";

const validationSchema = yup.object({
  // id_caballete: yup.string().required('Caballete es requerido'),
  cod_interno: yup.string().required('Serie requerido'),
});

const TransladoLaboratorio = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [xd, setXd] = useState("");
  const [cab, setCab] = useState("");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [modalOpen, setModalOpen] = useState(false);
  const USER = secureStorage.getItem('id');
  const EMPRESA = secureStorage.getItem('cod_empresa') || 1;

  const formik = useFormik({
    initialValues: {
      id: '',
      id_usuario: USER,
      id_producto: '',
      id_orden_produccion: '',
      serie: '',
    },
    validationSchema,

    
    onSubmit: async (values, { setFieldValue }) => {
      setIsLoading(true);

      try {

        if (!xd) {
          throw new Error("No se encontraron datos para el código interno");
        }
    
        const valuesToSend = {
          id_producto: data.id_producto,
          id_orden_produccion: data.id,
          serie: data.serie,
          id_usuario: parseInt(USER),
        };
    
        const edit = {
          id_caballete: 226,
        };
    
        // Simulación de retraso
        await new Promise((resolve) => setTimeout(resolve, 2000));
    
        const response = await PostDatosStockLaboratorio(valuesToSend);
        // Enviar datos
        // await putChapaOrden(xd.id, edit);
        // fetchPrueba();
        setRegistrationSuccess(true);
        setFieldValue("cod_interno", "");
        setFilteredData([]);
      } catch (error) {
        console.error("Error en el proceso:", error);
        setRegistrationError(true);
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    }
    
  });

useEffect(() => {
  const fetchDatosPorCodigo = async () => {
    const codInterno = formik.values.cod_interno;

    if (codInterno && codInterno.length > 8) {
      try {
        const result = await getChapas(codInterno);
        setData(result);
        const etiqueta = await getSerieEtiqueta(codInterno);
        setXd(etiqueta);
        if (etiqueta) {
          // Mostrás el resultado en el grid
          setFilteredData([etiqueta]);
        } else {
          setFilteredData([]);
        }
      } catch (err) {
        console.error("Error al obtener datos por cod_interno:", err);
        setFilteredData([]);
      }
    }
  };

  fetchDatosPorCodigo();
}, [formik.values.cod_interno]);


  const columns = [
    { field: "serie", headerName: "serie", flex: 0.5 },
    {
      field: "cod",
      headerName: "Producto",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "clasificacion",
      headerName: "Clasificación",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
  ];


  return (
    <Box m="20px" sx={{ overflowY: "auto", maxHeight: "100vh", '&::-webkit-scrollbar': { width: '8px' }, '&::-webkit-scrollbar-track': { background: 'transparent' }, '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0, 0, 0, 0.2)', borderRadius: '10px' }, '&::-webkit-scrollbar-thumb:hover': { backgroundColor: 'rgba(0, 0, 0, 0.4)' } }}>
    {/* <Box m="20px"> */}
      <Box display="flex" justifyContent="space-between" p={0}>
        <Header title="Translado de Chapas" subtitle="Transladar Chapas" />
        <Box display="flex" alignItems="center">
          <Box
            display="flex"
            backgroundColor={colors.primary[400]}
            borderRadius="3px"
            height={"40%"}
            width={"90%"}
            ml={1}
            sx={{ overflowY: "auto", maxHeight: "100vh" }}
          >
            {/* <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Buscar"
              value={searchValue}
              onChange={handleSearchChange}
            /> */}
            {/* <IconButton type="button" sx={{ p: 1 }}>
              <SearchIcon />
            </IconButton> */}
          </Box>
        </Box>
      </Box>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
          "& .estado-pendiente": {
            backgroundColor: "#740017",
            textShadow: "2px 2px 2px 2px #ffffff",
            "&:hover": {
              backgroundColor: "rgb(27 33 54) !important",
            },
          },
          "& .estado-completo": {
            backgroundColor: "green",
            textShadow: "2px 2px 2px 2px #ffffff",
            "&:hover": {
              backgroundColor: "rgb(27 33 54) !important",
            },
          },
          "& .estado-en-proceso": {
            backgroundColor: "#ff6105",
            textShadow: "2px 2px 2px 2px #ffffff",
            color: "white !important",
            "&:hover": {
              backgroundColor: "rgb(27 33 54) !important",
            },
          },
          "& .estado-default": {
            color: "gray",
            textShadow: "2px 2px 2px 2px #ffffff",
            "&:hover": {
              backgroundColor: "rgb(27 33 54) !important",
            },
          },
        }}
      >
        <form onSubmit={formik.handleSubmit} style={{ width: '100%' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                label="Serie"
                name="cod_interno"
                value={formik.values.cod_interno || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.cod_interno && Boolean(formik.errors.cod_interno)}
                helperText={formik.touched.cod_interno && formik.errors.cod_interno}
              />
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="end" mt="-3vh">
                <Button type="submit" color="secondary" variant="contained" sx={{ background: "#cedc00",
                  marginBottom: "5vh",
                  height: "6vh",
                  width: isNonMobile ? 'auto' : '100%',
                  marginTop: "3.5vh"
                }}>
                  Transladar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
        
        {registrationSuccess && <ModalSucces open={registrationSuccess} onClose={() => setRegistrationSuccess(false)} />}
        {registrationError && <ModalError open={registrationError} onClose={() => setRegistrationError(false)} error={error} />}
        <ModalCharge isLoading={isLoading} />
        <ModalCaballete
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onSelect={(data) => {
            setCab(data)
            formik.setFieldValue("descripcion", data.descripcion);
            formik.setFieldValue("id_caballete", data.id);
            setModalOpen(false);
          }}
          serviceType={0}
        />
  
        {/* Tabla de datos */}
        {filteredData && (
          <DataGrid
            rows={filteredData}
            columns={columns}
            getRowId={(row) => row.id}
            components={{ Toolbar: GridToolbar }}
            // getRowClassName={getRowClassName}
            disableMultipleSelection={true}
            sx={{
              "& .MuiDataGrid-root": {
                border: "none",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
              },
              "& .name-column--cell": {
                color: colors.greenAccent[300],
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: colors.blueAccent[900],
                borderBottom: "none",
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: colors.primary[400],
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "none",
                backgroundColor: colors.blueAccent[900],
              },
              "& .MuiCheckbox-root": {
                color: `${colors.greenAccent[200]} !important`,
              },
              "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                color: `${colors.grey[100]} !important`,
              },
              "& .estado-pendiente": {
                backgroundColor: "#740017",
                textShadow: "2px 2px 2px 2px #ffffff",
                "&:hover": {
                  backgroundColor: "rgb(27 33 54) !important",
                },
              },
              "& .estado-completo": {
                backgroundColor: "green",
                textShadow: "2px 2px 2px 2px #ffffff",
                "&:hover": {
                  backgroundColor: "rgb(27 33 54) !important",
                },
              },
              "& .estado-en-proceso": {
                backgroundColor: "#ff6105",
                textShadow: "2px 2px 2px 2px #ffffff",
                color: "white !important",
                "&:hover": {
                  backgroundColor: "rgb(27 33 54) !important",
                },
              },
              "& .estado-default": {
                color: "gray",
                textShadow: "2px 2px 2px 2px #ffffff",
                "&:hover": {
                  backgroundColor: "rgb(27 33 54) !important",
                },
              },
            }}
          />
        )}
      </Box>
    </Box>
  );
  };
  
  export default TransladoLaboratorio;
  